import { FieldError } from 'react-hook-form';
import { BasicError } from './BasicError';

interface InputErrorProps {
  error?: Pick<FieldError, 'message'>;
  name: string;
  className?: string;
}

export const InputError = ({ error, name, className = '' }: InputErrorProps) =>
  error?.message && <BasicError error={error.message} name={name} className={className} />;
